module.exports = __webpack_public_path__ + "static/media/login_bg.09b7f8ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login_bg.jpg
// module id = 589
// module chunks = 0